import { render, staticRenderFns } from "./GradeUpdateDialog.vue?vue&type=template&id=3ff96dc7"
import script from "./GradeUpdateDialog.vue?vue&type=script&lang=js"
export * from "./GradeUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports